export const envConfig = {
  isProd: false,
  apiHeadDev: process.env.REACT_APP_API_HEAD_DEV,
  apiHeadProd: process.env.REACT_APP_API_HEAD_PROD,
  oneSignalAppIdProd: process.env.REACT_APP_ONESIGNAL_APP_ID_PROD,
  oneSignalAppIdDev: process.env.REACT_APP_ONESIGNAL_APP_ID_DEV,
};

//////////////////// API HEAD  ////////////////////
export const ApiHead = envConfig.isProd
  ? envConfig.apiHeadProd
  : envConfig.apiHeadDev;

//////////////////// TOKEN AND IDS  ////////////////////
export const googleClientId = `${process.env.REACT_APP_GOOGLE_CLIENT_ID}`;

export const PAYU_BASE_URL = envConfig.isProd
  ? process.env.REACT_APP_PAYU_BASE_URL
  : process.env.REACT_APP_PAYU_BASE_DEV_URL;

export const MERCHANT_KEY = envConfig.isProd
  ? process.env.REACT_APP_MERCHANT_KEY
  : process.env.REACT_APP_MERCHANT_DEV_KEY;

export const MERCHANT_SALT = envConfig.isProd
  ? process.env.REACT_APP_MERCHANT_SALT
  : process.env.REACT_APP_MERCHANT_DEV_SALT;

export const udf1 = `${process.env.REACT_APP_UDF1}`;

export const mixpanelToken = envConfig.isProd
  ? `${process.env.REACT_APP_MIXPANEL_TOKEN}`
  : `${process.env.REACT_APP_MIXPANEL_DEV_TOKEN}`;

export const PAYU_TEST_PAYMENT_URL = `${process.env.REACT_APP_PAYU_TEST_PAYMENT_URL}`;

//////////////////// APIS ENDPOINTS  ////////////////////

export const ApiCollection = {
  user: {
    login: `${ApiHead}/assessment/user/login/`,
    signup: `${ApiHead}/assessment/user/signup/`,
    forgotPassword: `${ApiHead}/assessment/user/password-reset/`,
    getProfileInfo: `${ApiHead}/assessment/auth/profile/`,
    getaAuthUser: `${ApiHead}/assessment/user/auth-profile/`, // when user logins with google
    updateProfile: `${ApiHead}/assessment/auth/update-user/`,
    getClasses: `${ApiHead}/assessment/info/classes/`,
    getStreams: `${ApiHead}/assessment/info/stream/`,
    changePassword: `${ApiHead}/assessment/user/change-password/`,
    // `${ApiCollection.user.getStreams}?class=${classValue}`
    applyCoupon: `${ApiHead}/exams/coupon/`,
  },
  exam: {
    getAssessmentList: `${ApiHead}/assessment/enrolled/`,
    getAssessmentShop: `${ApiHead}/assessment/shop/`,
    getFeaturedAssessments: `${ApiHead}/assessment/shop/`,
    getExamQuestions: `${ApiHead}/assessment/questions`, // :id
    getGradingQuestions: `${ApiHead}/assessment/student/`,
    getAnswerKey: `${ApiHead}/assessment/answer`,
    approveExam: `${ApiHead}/assessment/enrolled/approve-assessment/`,
  },
  auth: {},
  organisation: {
    getOrganisationDetail: `${ApiHead}/assessment/organisation/`,
  },
  payment: {
    logFailure: envConfig.isProd
      ? `${ApiHead}/assessment/user/payment-failed/`
      : `${ApiHead}/assessment/user/payment-failed/`,

    //  PAYU_TEST_PAYMENT_URL
    logSuccess: envConfig.isProd
      ? `${ApiHead}/assessment/user/payment-success/`
      : `${ApiHead}/assessment/user/payment-success/`,
    //PAYU_TEST_PAYMENT_URL
  },
  subject: {
    getList: `${ApiHead}/exams/subject/`,
    getDetails: `${ApiHead}/exams/test-types/`,
    getChapters: `${ApiHead}/exams/chapter/`,
    generateQuestionPaper: `${ApiHead}/exams/student/exam/`,
    examInstructions: `${ApiHead}/exams/student/instruction/`,
    getQuestions: `${ApiHead}/exams/student/start/`, // ?enrolled=1
    uploadAnswer: `${ApiHead}/exams/student/upload-answer/`,
    submitTest: `${ApiHead}/exams/student/submit-test/`,
    getGrading: `${ApiHead}/exams/student/score-sheet/`,
    validateLockedSubject: `${ApiHead}/assessment/validate-subscription/`,
    getAnalysis: `${ApiHead}/exams/analysis/`,
  },
};
